import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';
import { SelectedProject } from '../fetchProjects/interfaces/useFetchProject.interface';

export const fetchProject = async (projectId: string): Promise<SelectedProject | undefined> => {
  const response = await api.get<SelectedProject>(`${API_URL}/v1/project/${projectId}`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });
  return response.data;
};
